
import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import isNil from 'lodash/isNil';
import { OPERATORS } from 'components/AgGrid/helpers/filterHelpers';

export const useAgConditionModel = ({ defaultCondition, defaultFromDate, defaultToDate }) => {
  const [type, setType] = useState(defaultCondition);
  const [dateFrom, setDateFrom] = useState(defaultFromDate ? moment(defaultFromDate) : null);
  const [dateTo, setDateTo] = useState(defaultToDate ? moment(defaultToDate) : null);

  const onChange = useCallback((date, isEndDate) => {
    const newDate = date?.toDate() || date;

    if (isEndDate) {
      setDateTo(newDate);
    } else {
      setDateFrom(newDate);
    }
  }, []);

  const resetToDefault = useCallback(() => {
    setType(defaultCondition);
    setDateFrom(!isNil(defaultFromDate) ? moment(defaultFromDate) : null);
    setDateTo(!isNil(defaultToDate) ? moment(defaultToDate) : null);
  }, [defaultCondition, defaultFromDate, defaultToDate]);

  useEffect(resetToDefault, [defaultCondition, defaultFromDate, defaultToDate, resetToDefault]);

  const isRangeError = type === OPERATORS.inrange ? !isNil(dateFrom) && isNil(dateTo) : false;
  const isError = isRangeError || isNil(dateFrom);

  return {
    type,
    setType,
    dateFrom,
    dateTo,
    onChange,
    resetToDefault,
    isRangeError,
    isError,
  };
};
